import { render } from "./SmsCode.vue?vue&type=template&id=212928ac&scoped=true"
import script from "./SmsCode.vue?vue&type=script&lang=js"
export * from "./SmsCode.vue?vue&type=script&lang=js"

import "./SmsCode.vue?vue&type=style&index=0&id=212928ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-212928ac"]])

export default __exports__